import styled from 'styled-components'

export const FieldError = styled.div`
  text-align: left;
  margin-top: 5px;
  color: #F8373E;
`



// WEBPACK FOOTER //
// ./src/atoms/FieldError.tsx